export const updatePageTitle = text => {
  document.title = text + ' | FACTS';
};

export default updatePageTitle;
